import { createAction } from 'typesafe-actions'
import { Chat } from './types'
export {
  fetchChatsInformationAction,
  fetchChatConfigAction,
  addArchiveChatAction,
  addChatAction,
  addMessageOnActiveChatAction,
  answerChatAction,
  deleteMessageFromChatAction,
  fetchMoreChatsAction,
  loadChatsByStatusAction,
  loadMessagesByChatIdAction,
  readMessagesFromChatAction,
  removeArchiveChatAction,
  setActiveChatAction,
  setActiveChatMessageAction,
  setActiveChatMessagesAction,
  updateActiveChatAction,
  updateArchiveChatAction,
  updateChatAction,
  clearActiveChatAction,
  setHasMoreChatsAction,
  cancelChatAction,
  createNewChatAction,
  closeChatAction,
  finalCloseChatAction,
  loadChatsBySearchAction,
  updateChatFirebaseAction,
  transferChatAction,
  transferChatToOperatorAction,
  customButtonCallAction,
  watchChatsCountAction,
  refreshChatsCountAction,
  stopWatchChatsCountAction,
  updateActiveChatMessageAction,
  updateMessageTextAction,
  addMessagesOnActiveChatAction,
  startChatAction,
  pauseChatAction,
  resumeChatAction,
  setChatFiltersAction,
  createNewGroupAction,
  exitGroupAction,
  addParticipantToGroupAction,
  removeParticipantToGroupAction,
  promoteAdminGroupAction,
  updateGroupAction,
  unPromoteAdminGroupAction,
  setChatsCountByStatusWhenSearchAction
} from './handles'

export const removeChat = createAction('@chat/REMOVE_CHAT')<Chat>()
